import FilterBoxItem from '../FilterBox/FilterBoxItem.vue'
export default FilterBoxItem;
